<div class="navbar navbar-fixed navbar-toggleable-sm navbar-deloitte-light">
    <div class="navbar-container justify-content-between">
        <div class="navbar-brand" href="#">
            <span class="navbar-mobile-title">
                Timeline
            </span>
        </div>
        <div>
            <input type="text" [(ngModel)]="searchTerm" class="form-control" placeholder="Search timeline..." />
        </div>
    </div>
</div>

<div class="container">
    <div class="row mt-5">
        <div class="col col-md-8 offset-md-2">
            @if (timeline.events && timeline.events.length > 0 && (timeline.events | eventfilter:searchTerm).length > 0) {
            <ul class="timeline">
                @for (event of timeline.events | eventfilter:searchTerm; track event) {
                <li class="timeline__event">
                    <div class="timeline__icon">
                        <i class="flag flag--{{event.country.code | lowercase}}"></i>
                    </div>
                    <div class="timeline__content">
                        <div class="card">
                            <div class="card-block">
                                <div class="row">
                                    <div class="col text-left">
                                        <h3 class="h5">
                                            {{ event.country.name }}
                                        </h3>
                                    </div>
                                </div>
                                <p class="text-muted" [innerHTML]="event.text">
                                </p>
                                @if (event.url && (event.url.includes('http') || event.url.includes('https'))) {
                                <a href="{{ event.url }}" target="_blank">
                                    <small>
                                        <i class="fa fa-external-link mr---xxx-small"></i>
                                        <strong>{{ event.url | truncate: ['32'] }}</strong>
                                    </small>
                                </a>
                                }
                            </div>
                            <div class="card-footer p-3">
                                <div class="row align-items-between">
                                    <div class="col">
                                        <small class="textBody--xs text-muted">{{ event.publishDate | date : 'dd MMMM y' }}</small>
                                    </div>
                                    <div class="col text-right">
                                        @if (event.url && (event.url.includes('http') || event.url.includes('https'))) {
                                        <a href="{{ event.url }}" class="textBody--xs" target="_blank">
                                            <span class="text-black mr---xxx-small text-muted">
                                                View update
                                            </span><i class="fa fa-arrow-circle-r- text-info-3"></i>
                                        </a>
                                        }
                                        @if (!event.url) {
                                        <a [routerLink]="[countryInformationRouteLink,event.country.code]" class="textBody--xs">
                                            <span class="text-black mr---xxx-small text-muted">
                                                View update
                                            </span><i class="fa fa-arrow-circle-r- text-info-3"></i>
                                        </a>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                }
            </ul>
            }
            <no-content-message [visible]="timeline.events && timeline.events.length == 0" message="There are currently no events"></no-content-message>
            <no-content-message [visible]="searchTerm.length > 0 && (timeline.events | eventfilter:searchTerm).length == 0" message="No matching search results"></no-content-message>
        </div>
    </div>
</div>
